import React, { Component } from 'react';
import ReactTooltip from "react-tooltip";
import styles from './Icon.module.sass';

const Icon = props => {
  const {
    name,
    className,
    style,
    iconPlaceholder
  } = props;
  const linkHref = `#${name}`;
  let renderIcon;
  iconPlaceholder ? renderIcon = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactTooltip, {
    className: styles["tooltip"],
    place: "right",
    effect: "float"
  }), /*#__PURE__*/React.createElement("svg", {
    className: `icon ${className || ''}`,
    "data-type": "info",
    "data-font": "robot",
    style: style,
    "data-tip": `${iconPlaceholder}`
  }, /*#__PURE__*/React.createElement("use", {
    href: linkHref
  }))) : renderIcon = /*#__PURE__*/React.createElement("svg", {
    className: `icon ${className || ''}`,
    style: style
  }, /*#__PURE__*/React.createElement("use", {
    href: linkHref
  }));
  return renderIcon;
};

export default Icon;